/**
 * Outputs a string that is spelled out by screen readers when
 * used with the 'aria-label' HTML attribute. It does this by splitting
 * up every character with a Word joiner
 */
export function spellOut(input: string): string {
	return input.split('').join('\u2060');
}
